export default API => ({
    // 获取可售卖的商品
    findSaleGoods() {
        return API({
            url: '/saas/v1/gongXin/homePage/findSaleGoods'
        })
    },
})
